import { useCallback, useEffect, useState } from "react";
import { isBrowser, isMobile, browserName, fullBrowserVersion, mobileModel, osVersion, osName } from "react-device-detect";
import { deviceInfo } from "../../../interface/MainInterface";
import { HttpClientApi } from "../../../interface/client-rest-api";
import "./ClientIVSPlayer.css";

interface propsType {
  endLoadInfo: boolean;
  broad_seq: string;
  broad_status: string;
  playbackUrl: string;
  streamState: string;
  videoStatusCallback: any;
  muted: boolean;
  webViewStatus: string;
  rehearsal: boolean;
}
export let player: any = null;

const clientApi = new HttpClientApi();

const _deviceInfo: deviceInfo = {
  isBrowser: isBrowser,
  isMobile: isMobile,
  browserName: browserName,
  fullBrowserVersion: fullBrowserVersion,
  mobileModel: mobileModel,
  osName: osName,
  osVersion: osVersion,
};

export const ClientIVSPlayer = (props: propsType) => {
  const PLAYBACK_URL = props.playbackUrl;
  const [broadStatus, setBroadStatus] = useState("");

  useEffect(() => {
    return () => {
      // 메모리 누수를 방지하기 위해서 컴포넌트 언마운트시 State를 초기화 한다.
      setBroadStatus("");
    };
  }, []);

  useEffect(() => {
    if (PLAYBACK_URL !== "") {
      mediaPlayerScriptLoaded();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PLAYBACK_URL]);

  const putErrorLog = async (errorMsg: string) => {
    try {
      const param = {
        command: "put_broaderror_data",
        broad_seq: props.broad_seq,
        device_info: _deviceInfo,
        error_msg: errorMsg,
      };

      await clientApi.put_broaderror_data(param);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setBroadStatus(props.broad_status);
    if (props.broad_status === "START") player.load(PLAYBACK_URL);
    if (props.broad_status === "READY") player.load(PLAYBACK_URL);
    if (props.streamState === "Stream Start" && props.broad_status === "START") player.load(PLAYBACK_URL);
  }, [props.streamState, props.broad_status, PLAYBACK_URL]);

  const mediaPlayerScriptLoaded = () => {
    const MediaPlayerPackage = window.IVSPlayer;
    if (!MediaPlayerPackage.isPlayerSupported) {
      console.warn("The current browser does not support the Amazon IVS player.");
      props.videoStatusCallback("unSupported");
      putErrorLog("UnSupported Browser");
    }

    const PlayerState = MediaPlayerPackage.PlayerState;
    const PlayerEventType = MediaPlayerPackage.PlayerEventType;

    // Initialize player
    player = MediaPlayerPackage.create({
      serviceWorker: {
        url: "amazon-ivs-service-worker-loader.js",
      },
    });
    player.attachHTMLVideoElement(document.getElementById("videoPlayer"));
    player.addEventListener(PlayerState.READY, onReady);
    player.addEventListener(PlayerState.IDLE, onIdle);
    player.addEventListener(PlayerState.PLAYING, onStatePlaying);
    player.addEventListener(PlayerState.ENDED, onStateEnd);
    player.addEventListener(PlayerEventType.ERROR, onError);
    player.addEventListener(PlayerEventType.TIME_UPDATE, onTimeUpdate);
    player.addEventListener(PlayerEventType.AUDIO_BLOCKED, onAudioBlocked);
    player.addEventListener(PlayerEventType.INITIALIZED, onInitialized);
    player.addEventListener(PlayerEventType.MUTED_CHANGED, onMutedChanged);
    player.addEventListener(PlayerEventType.NETWORK_UNAVAILABLE, onNetworkUnavailable);
    player.addEventListener(PlayerEventType.PLAYBACK_RATE_CHANGED, onPlaybackRateChanged);
    player.addEventListener(PlayerEventType.QUALITY_CHANGED, onQualityChanged);
    player.addEventListener(PlayerEventType.PLAYBACK_BLOCKED, onPlaybackBlocked);

    window.addEventListener("focus", fncAutoPlay);
    function fncAutoPlay() {
      if (props.webViewStatus === "ios" && props.playbackUrl !== "") {
        player.setAutoplay(true);
        player.load(props.playbackUrl);
        player.play();
      }
    }
    // Setup stream and play
    player.setAutoQualityMode(true);
    player.setLiveLowLatencyEnabled(true);
    player.setMuted(true);
    player.setVolume(1.0);
    player.setAutoplay(true);

    // console.log("props.rehearsal : ", props.rehearsal);
    if (props.rehearsal) {
      player.load(PLAYBACK_URL);
      player.play();
    } else {
      if (props.broad_status === "START") {
        player.load(PLAYBACK_URL);
        player.play();
      }
    }
  };

  const onIdle = useCallback(
    (cue: any) => {
      const newState = player.getState();
      console.info(`Player State - ${newState}`);
      props.videoStatusCallback("onIdle");
      window.addEventListener("visibilitychange", visibleCheck, false);
      function visibleCheck(e: any) {
        e.stopPropagation();
        if (document.visibilityState === "visible" && broadStatus === "START") {
          player.play();
        }
      }

      if (broadStatus === "START") {
        player.play();
      }
    },
    [props, broadStatus]
  );

  const onReady = (cue: any) => {
    const newState = player.getState();
    console.info(`Player State - ${newState}`);
    props.videoStatusCallback("onReady");
  };

  const onStatePlaying = (cue: any) => {
    const newState = player.getState();
    console.info(`Player State - ${newState}`);
    props.videoStatusCallback("onStatePlaying");
  };

  const onStateEnd = (cue: any) => {
    const newState = player.getState();
    console.info(`Player State - ${newState}`);
    props.videoStatusCallback("onStateEnd");
  };

  const onError = useCallback(
    (err: any) => {
      console.warn("Player Event - ERROR:", err);
      props.videoStatusCallback("onError");
      putErrorLog(JSON.stringify(err));
      if (broadStatus === "START") {
        player.play();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props, broadStatus]
  );

  const onTimeUpdate = (evt: any) => {};

  const onAudioBlocked = (evt: any) => {
    console.log("onAudioBlocked");
  };
  const onInitialized = (evt: any) => {
    console.log("onInitialized");
  };
  const onMutedChanged = (evt: any) => {
    console.log("onMutedChanged");
  };
  const onNetworkUnavailable = (evt: any) => {
    console.log("onNetworkUnavailable");
  };
  const onPlaybackRateChanged = (evt: any) => {
    console.log("onPlaybackRateChanged");
  };
  const onQualityChanged = (evt: any) => {
    console.log("onQualityChanged : ", evt);
  };
  const onPlaybackBlocked = (evt: any) => {
    console.log("onPlaybackBlocked");
  };

  return (
    <>
      <video id="videoPlayer" className="client-video" poster={"/images/ready_img.png"} playsInline muted autoPlay></video>
    </>
  );
};
